// extracted by mini-css-extract-plugin
export default {"modalText":"WDptotLSqhY5TSRFXyeD"};